import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

interface MapDetails extends Vue {
    latitude: number;
    longitude: number;
}

Vue.use(Vuex);

const MapDetails = {
    computed: {
        latitude: {
            get(this: MapDetails) { return Number(this.$store.state.details.latitude || 0); },
        },
        longitude: {
            get(this: MapDetails) { return Number(this.$store.state.details.longitude || 0); },
        },
        street: {
            get(this: MapDetails) { return (this.$store.state.details.street || this.$store.state.details.objectStreet || ""); },
        },
        zip: {
            get(this: MapDetails) { return (this.$store.state.details.zip || this.$store.state.details.objectZip || ""); },
        },
        city: {
            get(this: MapDetails) { return (this.$store.state.details.city || this.$store.state.details.objectCity || ""); },
        },
        isShow: {
            get(this: MapDetails) {
                const n = this.$route.name;
                return (n === "realestatedetail" || n === "rentdetail") && this.longitude !== 0 && this.latitude !== 0;
            },
        },
    },
} as ComponentOptions<MapDetails>;

export { MapDetails };



// WEBPACK FOOTER //
// ./src/components/map-details.ts